import { Box, Typography } from "@mui/material";
import React from "react";
import {
  CustomTableComponent,
  Column,
  getReservationStatus,
} from "../../../shared/elements/customTable.component";
import { RecentReservation } from "../dto/dashboard.dto";
import { formatDateTime } from "../../../shared/utils/format.util";

export interface RecentReservationsProps {
  data: RecentReservation[];
}

const columns: Column[] = [
  { key: "clientName", label: "Client" },
  { key: "type", label: "Type" },
  {
    key: "price",
    label: "Prix",
    render: (value) => (value != null ? `${value} €` : "—"),
  },
  {
    key: "status",
    label: "Status",
    render: (value) => {
      const status = getReservationStatus(value);
      return (
        <Typography fontWeight="600" fontSize="0.8rem" sx={{ color: status.color }}>
          {status.label}
        </Typography>
      );
    },
  },
  {
    key: "createdAt",
    label: "Créée le",
    render: (value) => formatDateTime(value),
  },
];

export const RecentReservationsComponent: React.FC<RecentReservationsProps> = ({
  data,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "#FFFDF7",
        borderRadius: "14px",
        padding: "18px 20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        flex: "1 1 380px",
        minWidth: 0,
      }}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#333", mb: 1.5 }}>
        Dernières réservations
      </Typography>
      {data.length === 0 ? (
        <Typography fontSize="0.8rem" color="gray">
          Aucune réservation pour le moment.
        </Typography>
      ) : (
        <CustomTableComponent columns={columns} rows={data} />
      )}
    </Box>
  );
};
